<div class="field-input-group input-group">
    @if (transcribing) {
        <div class="form-audio-preview form-control form-control-md is-focused">
            <canvas
                #voiceCanvas
                class="voice-visualizer"
                [width]="maxCanvasWidth()"
                height="21">
            </canvas>
        </div>
        <div class="field-input-group-actions align-items-center d-flex height-full mr-12">
            <button class="btn btn-circle btn-transparent2" (click)="cancelTranscription()">
                  <svg ycnIcon [name]="'icon-close'"></svg>
            </button>
            <button class="btn btn-transparent2" (click)="stopTranscription()">Done</button>
          </div>
    } @else {
        @if (processing || settingUpTranscription) {
            <div class="form-audio-preview form-control form-control-md is-focused">
                <span class="ng-binding"><span class="loader-dots"></span></span>
            </div>
        } @else {
            <input
                    [value]="inputText"
                    (input)="onInputChange($event)"
                    (keydown.enter)="onEnterPressed()"
                    class="form-control field-input ng-pristine ng-valid ng-empty ng-touched"
                    type="text"
                    placeholder="{{placeholder}}"
            >
            <div class="field-input-group-actions">
                <span class="btn btn-circle btn-transparent2" (click)="startTranscription()">
                    <svg ycnIcon ycnTooltip [name]="'icon-microphone'" [tooltipTitle]="'Dictation'" [tooltipIgnoreViewport]="true" [tooltipPlacement]="'top'"></svg>
                </span>
            </div>
        }
    }
</div>

